<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
              <p
                v-if="current_submenu.visible_to == 'everyone' || (membership ? current_submenu.visible_to == membership.rate_id : false)"
                v-html="content"></p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import axios from 'axios'

export default {
  name: 'show-article',
  data () {
    return {
      current_submenu: null,
      current_membership_article: null,
      content: null,
    }
  },
  components: {
    'page-title': PageTitle
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'restaurantContact', 'restaurantAddress', 'openingHours', 'reservationConfig', 'rid'
    ]),
    ...mapGetters('auth', [
      'authenticated'
    ]),
    ...mapGetters('member', [
      'isMember', 'profile', 'membership'
    ]),
    ...mapGetters('menu', [
      'submenu'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    aboutStyle () {
      return {
        fontSize: '13px',
        color: this.theme.title_color
      }
    },
    tncStyle () {
      return {
        color: this.theme.title_color
      }
    }
  },
  methods: {
    getContent() {
      this.current_submenu = this.submenu.find(x => x.id == this.$route.params.submenu_id)
      if (this.current_submenu.content !== '' && this.current_submenu.content !== null)
        this.content = this.current_submenu.content
      // this.content = this.current_submenu.content.replace(/"(?:height):[^;]*; +(width):[^;]*"/, '"height:180px; width:100%;"')
    },
  },
  async beforeMount() {
    await this.getContent();
  },
  watch: {
    '$route' (to, from) {
      if (from.params.submenu_id !== to.params.submenu_id) {
        return this.getContent()
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
  padding: 0 16px;
}
.middle {
  padding: 2px 4px 2px 2px;
}
.tnc-title {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
}
.tnc {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/show_article.vue